import { Switch } from '@lmn/design-system';
import type { URLParameters } from '@/app/common/urlParameters.ts';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import type { SearchParams } from '@/server/searchParams.ts';

import { useSearchCommonPageData } from '@/app/components/search/searchCommonPageProvider.tsx';
import { getBooleanFromString } from '../../../utils/query2';
import getSearchParams, { getSearchParamsClient } from '../../../common/getSearchParams';
// eslint-disable-next-line import/no-cycle
import { ToggleBannerContainer, ToggleBannerToggler } from './styled';
import { removeSearchParams } from '../../Filters/utils';

export enum BANNER_TYPES {
  INFO = 'info',
  BASE = 'base',
}

type ToggleBannerProps = {
  text: string;
  switchText?: string;
  type?: BANNER_TYPES;
  searchParam: URLParameters;
  invertToggle: boolean;
  handleToggleBannerOnChange: (isActive: string) => void;
};

const ToggleBanner = ({
  text,
  switchText,
  type = BANNER_TYPES.BASE,
  searchParam,
  invertToggle,
  handleToggleBannerOnChange,
}: ToggleBannerProps) => {
  const { searchParams: searchParamsServer } = usePageWrapperData();
  const { handleFiltersChanged } = useSearchCommonPageData();
  const searchParams = getSearchParamsClient(searchParamsServer);
  const isActiveFromSearchParams = getBooleanFromString(searchParams[searchParam]);

  const handleOnChange = (isActive: boolean) => {
    handleToggleBannerOnChange(isActive ? 'true' : 'false');

    const searchParamsAfterChange = getSearchParams();
    let appliedFilters = removeSearchParams(searchParamsAfterChange);
    let updatedValue: string | undefined;

    if (isActive) {
      updatedValue = invertToggle ? undefined : '1';
    } else {
      updatedValue = invertToggle ? '1' : undefined;
    }

    appliedFilters = { ...appliedFilters, [searchParam]: updatedValue } as SearchParams;

    handleFiltersChanged({
      searchParams: searchParamsAfterChange,
      appliedFilters,
    });
  };

  return (
    <ToggleBannerContainer type={type}>
      {text}
      <ToggleBannerToggler>
        {switchText && (
          <Switch
            label={switchText}
            onChange={handleOnChange}
            ltr={true}
            checked={invertToggle ? !isActiveFromSearchParams : isActiveFromSearchParams}
          />
        )}
      </ToggleBannerToggler>
    </ToggleBannerContainer>
  );
};

export default ToggleBanner;
